import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import type {
    IPImageFtoSearchApi,
    ILocItemsResponse,
    ILocPredictRequest,
    ILocPredictResponse,
    ILocTreeByKeywordResponse,
    ISaveConditionsRequest,
} from '../image-fto-search-api'

@injectable()
export class IPImageFtoSearchApiImpl extends PsHttpService implements IPImageFtoSearchApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-telecom-api/telecom`,
        }
    }

    getLOCItemsData(code?: string) {
        return this.get<PatSnapCommonResponseData<ILocItemsResponse>>({
            url: '/image-search/tool/classification/helper-section-subclass',
            cache: true,
            params: {
                type: 'loc',
                code,
            },
        }).then(res => {
            return res?.data as unknown as ILocItemsResponse
        })
    }

    getLOCTreeByKeyword(keyword?: string) {
        return this.get<PatSnapCommonResponseData<ILocTreeByKeywordResponse>>({
            url: '/image-search/tool/classification/helper-search',
            params: {
                type: 'loc',
                keyword,
            },
        }).then(res => {
            return res?.data as unknown as ILocTreeByKeywordResponse
        })
    }

    predictLOC(request: ILocPredictRequest) {
        return this.post<PatSnapCommonResponseData<ILocPredictResponse>>({
            url: '/image-search/tool/loc-predict',
            data: request,
        }).then(res => {
            return (res?.data || []) as unknown as ILocPredictResponse
        })
    }

    saveConditions(jobId: string, request: ISaveConditionsRequest) {
        return this.post({
            url: '/image-search/tool/search/save-conditions',
            headers: {
                agent_job_id: jobId,
            },
            data: request,
        }).then((res) => {
            return res?.data as any
        })
    }
}
